import React, {useState, useEffect} from "react";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem} from "reactstrap";
import LanguageSelector from "./LanguageSelector";
import {useTranslation} from "react-i18next";
import {Link, Events} from "react-scroll";
import { ReactComponent as Logo } from '../logo.svg';

function Header() {
    useEffect(() => {
        Events.scrollEvent.register("begin", () => {
        });
        Events.scrollEvent.register("end", () => {
        });
        return () => {
            Events.scrollEvent.remove("begin");
            Events.scrollEvent.remove("end");
        };
    }, []);

    const [isOpen, setIsOpen] = useState(false);
    const toggle = (page) => {
        setIsOpen(!isOpen);
        setActive(page);
    };
    const closeMenu = () => setIsOpen(false);
    const [active, setActive] = useState("eco-friendly");

    const {t} = useTranslation();

    return <div>
        <Navbar className="customNavbar" light expand="xl" fixed="top" >
            <NavbarBrand href="/">

                <Link to="home"
                      smooth={true}
                      duration={500}
                      className={`nav-link`}
                      offset={-70}
                      onClick={() => toggle("eco-friendly")}
                >
                    <Logo />
                    <span>SOR Praktiker nonwoven</span>
                </Link>
            </NavbarBrand>
            <NavbarToggler onClick={toggle}/>
            <Collapse isOpen={isOpen} navbar>
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <Link to="aboutUs"
                              smooth={true}
                              duration={500}
                              className={`nav-link ${active === "aboutUs" ? "active" : ""}`}
                              offset={-70}
                              onClick={() => toggle("aboutUs")}
                        >
                            {t("aboutUs")}
                        </Link>
                    </NavItem>
                    <NavItem>
                        <Link to="advantages"
                              smooth={true}
                              duration={500}
                              className={`nav-link ${active === "advantages" ? "active" : ""}`}
                              offset={-70}
                              onClick={() => toggle("advantages")}
                        >
                            {t("advantages")}
                        </Link>
                    </NavItem>
                    <NavItem>
                        <Link to="products"
                              smooth={true}
                              duration={500}
                              className={`nav-link ${active === "products" ? "active" : ""}`}
                              offset={-70}
                              onClick={() => toggle("products")}
                        >
                            {t("products")}
                        </Link>
                    </NavItem>
                    <NavItem>
                        <Link to="references"
                              smooth={true}
                              duration={500}
                              className={`nav-link ${active === "references" ? "active" : ""}`}
                              offset={-70}
                              onClick={() => toggle("references")}
                        >
                            {t("references")}
                        </Link>
                    </NavItem>
                    <NavItem>
                        <Link to="contact"
                              smooth={true}
                              duration={500}
                              className={`nav-link ${active === "contact" ? "active" : ""}`}
                              offset={-70}
                              onClick={() => toggle("contact")}
                        >
                            {t("contact")}
                        </Link>
                    </NavItem>
                </Nav>
                <Nav className="ms-auto" navbar>
                    <NavItem>
                        <LanguageSelector onLanguageChange={closeMenu}/>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
    </div>
}

export default Header;

